module.exports = __webpack_public_path__ + "static/media/illustration-people.3086f28b.svg";